var app = function() {
    "use strict";
    var config = {
        gaTrackingId: "UA-1561331-3"
    }, analytics = function() {
        if (!config.gaTrackingId) return;
        /* jshint ignore:start */ (function(i, s, o, g, r, a, m) {
            i["GoogleAnalyticsObject"] = r;
            i[r] = i[r] || function() {
                (i[r].q = i[r].q || []).push(arguments);
            }, i[r].l = 1 * new Date();
            a = s.createElement(o), m = s.getElementsByTagName(o)[0];
            a.async = 1;
            a.src = g;
            m.parentNode.insertBefore(a, m);
        })(window, document, "script", "//www.google-analytics.com/analytics.js", "ga");
        ga("create", config.gaTrackingId, "auto");
        ga("send", "pageview");
    /* jshint ignore:end */ };
    return {
        init: function() {
            analytics();
        }
    };
}();
app.init();

//# sourceMappingURL=index.e8a099fc.js.map
